var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.likeCount > 0
    ? _c(
        "w-link",
        {
          directives: [
            {
              name: "tooltip",
              rawName: "v-tooltip",
              value: _vm.tooltip,
              expression: "tooltip",
            },
          ],
          on: {
            click: function ($event) {
              return _vm.onClick()
            },
          },
        },
        [
          _vm.likeCount > 0
            ? _c("span", { staticClass: "count" }, [
                _vm._v(_vm._s(_vm.likeCount)),
              ])
            : _vm._e(),
          _c("w-fa", { attrs: { icon: [_vm.iconPrefix, "thumbs-up"] } }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }